import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { DocumentListWorkspace } from '@/components/DocumentListWorkspace';
import { useI18n } from '@/lib/i18n';
import { type InvoiceListSearch, InvoiceListSearchSchema } from '@/lib/invoice-list-search';

export const Route = createFileRoute('/invoices/')({
  validateSearch: (search) => InvoiceListSearchSchema.parse(search),
  component: InvoiceListPage,
});

function InvoiceListPage() {
  const { t } = useI18n();
  const navigate = useNavigate({ from: Route.fullPath });
  const search = Route.useSearch();

  return (
    <DocumentListWorkspace
      documentType="invoice"
      search={search}
      copy={{
        sectionLabel: t('invoiceList.sectionLabel'),
        pageTitle: t('invoiceList.pageTitle'),
        pageDescription: t('invoiceList.pageDescription'),
        uploadButton: t('invoiceList.newInvoice'),
        uploadButtonAria: t('invoiceList.newInvoiceAria'),
        loadingTitle: t('invoiceList.loadingTitle'),
        count: (count) => t('invoiceList.count', { count }),
        loadError: t('invoiceList.loadError'),
        errorTitle: t('invoiceList.errorTitle'),
        retry: t('invoiceList.retry'),
      }}
      onSearchChange={(next) => {
        void navigate({
          search: (prev) => ({ ...(prev as InvoiceListSearch), ...next }),
          replace: false,
        });
      }}
      onOpenDetail={(id) => {
        void navigate({ to: '/invoices/$id', params: { id } });
      }}
    />
  );
}
